import React from "react";
import { Link } from "react-router-dom";
import linkdin from "../assets/linkdin.png";
import facebook from "../assets/facebook.svg";
import instagram from "../assets/instagram.svg";
import googlePlay from "../assets/google-play.png";
import appStore from "../assets/app-store.png";

const Footer = () => {
  return (
    <footer className="footer pt-5 pb-4">
      <div className="container">
        <div className="row">

          {/* Left Section */}
          <div className="col-lg-3 col-md-6">
            <h4 className="mb-md-5 mb-3 text-center text-md-start txGreen">
              Secure Payments That Help Your Business Grow in the Digital World
            </h4>

            <h5 className="text-black-50 text-center text-md-start">
              Social Media
            </h5>

            <div className="footer-social d-flex gap-3 justify-content-center justify-content-md-start">
              <a href="https://www.linkedin.com/company/aepspayservices">
                <img src={linkdin} alt="linkedin" />
              </a>

              {/* <a href="#">
                <img src={twitter} alt="twitter" />
              </a> */}

              <a href="https://www.facebook.com/aepspayservices/">
                <img src={facebook} alt="facebook" />
              </a>

              <a href="https://www.instagram.com/aepspayservices/">
                <img src={instagram} alt="instagram" />
              </a>
            </div>
          </div>

          {/* Middle Section */}
          <div className="col-lg-5 py-4 py-md-0 col-md-6">
            <ul className="footer-menu d-grid p-0 m-0">

              <li className="d-inline-block">
                <Link to="/service/aepsservice" className="text-black-50 text-decoration-none">
                  AEPS Services
                </Link>
              </li>

               <li className="d-inline-block">
                <Link to="/service/bbpsservice" className="text-black-50 text-decoration-none">
                  BBPS Services
                </Link>
              </li>

              <li className="d-inline-block">
                <Link to="/service/upiatmservice" className="text-black-50 text-decoration-none">
                  UPI ATM Service
                </Link>
              </li>

              <li className="d-inline-block">
                <Link to="/service/ittechnology" className="text-black-50 text-decoration-none">
                  IT & Technology Services
                </Link>
              </li>

              <li className="d-inline-block">
                <Link to="/service/taxationservices" className="text-black-50 text-decoration-none">
                  Taxation Services
                </Link>
              </li>

              <li className="d-inline-block">
                <Link to="/service/atminstallation" className="text-black-50 text-decoration-none">
                  ATM Installation Services
                </Link>
              </li>

              <li className="d-inline-block">
                <Link to="/service/microatmservices" className="text-black-50 text-decoration-none">
                  Micro ATM Services
                </Link>
              </li>

              {/* <li className="d-inline-block">
                <Link to="/service/businesslegal" className="text-black-50 text-decoration-none">
                  Business Legal
                </Link>
              </li> */}

              <li className="d-inline-block">
                <Link to="/service/registationservices" className="text-black-50 text-decoration-none">
                  Registration Services
                </Link>
              </li>

              <li className="d-inline-block">
                <Link to="/service/aadharpayservices" className="text-black-50 text-decoration-none">
                  Aadhaar Pay Services
                </Link>
              </li>

              <li className="d-inline-block">
                <Link to="/service/apiintegration" className="text-black-50 text-decoration-none">
                  API Services
                </Link>
              </li>

            </ul>
          </div>

          {/* App Download Section */}
          <div className="col-lg-4 col-md-12 mt-4 mt-lg-0">
            <div className="bg-white text-center rounded-3 p-3">

              <h4 className="txGreen">Download App</h4>

              <p className="text-black-50">
                let’s make your life easier!
              </p>

              <div className="DownloadApp d-flex gap-3 justify-content-center">
                <a href="#">
                  <img src={googlePlay} alt="google-play" />
                </a>

                <a href="#">
                  <img src={appStore} alt="app-store" />
                </a>
              </div>

            </div>
          </div>

        </div>

        {/* Bottom Footer */}
        <div className="d-flex justify-content-md-between border-top pt-3 mt-4 flex-wrap justify-content-center gap-2">

          <div className="d-flex gap-4">
            <Link
              to="/privacy-policy"
              className="text-black-50 text-decoration-none"
            >
              Privacy Policy
            </Link>

            <Link
              to="/terms-and-conditions"
              className="text-black-50 text-decoration-none"
            >
              Terms of Use
            </Link>
          </div>

          <p className="text-black-50 mb-0">
            © Copyright AePSPay. All Rights Reserved
          </p>

        </div>

      </div>
    </footer>
  );
};

export default Footer;